import moment from 'moment/moment';
import { CalendarContextType } from './CalendarContextType';
import { DATE_FORMAT } from '../consts';
import { CalendarView } from '../calendarWrapper/CalendarWrapper';

export const initialCalendarContextState: CalendarContextType = {
  openEditOrderDrawer: () => {},
  closeEditOrderDrawer: () => {},
  editOrderDrawerState: { isOpen: false },

  openExperienceAvailabilityDrawer: () => {},
  closeExperienceAvailabilityDrawer: () => {},
  experienceAvailabilityDrawerState: { isOpen: false },

  openDeleteOrderDialog: () => {},
  closeDeleteOrderDialog: () => {},
  deleteOrderDialogState: { isOpen: false },

  openDeleteEventDialog: () => {},
  closeDeleteEventDialog: () => {},
  deleteEventDialogState: { isOpen: false },

  openDeleteUnavailabilityDialog: () => {},
  closeDeleteUnavailabilityDialog: () => {},
  deleteUnavailabilityDialogState: { isOpen: false },

  openDeleteShiftDialog: () => {},
  closeDeleteShiftDialog: () => {},
  deleteShiftDialogState: { isOpen: false },

  openEditShiftDialog: () => {},
  closeEditShiftDialog: () => {},
  editShiftDialogState: { isOpen: false },

  users: [],
  setUsers: () => {},

  startDate: moment().format(DATE_FORMAT),
  endDate: moment().format(DATE_FORMAT),
  setStartDate: () => {},
  setEndDate: () => {},

  calendarView: 'week' as CalendarView,
  setCalendarView: (_: CalendarView) => {},

  currentDate: moment().format(DATE_FORMAT),
  setCurrentDate: (_: string) => {},

  userColors: {},
  selectedUsersIds: [],
  setSelectedUsersIds: () => {},
  shouldBlockSwiping: false,
  setShouldBlockSwiping: () => {},

  isAnyThingOpen: false,
};
